import { observer } from 'mobx-react-lite'
import { SectionCollapse } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'
import { StepObjectiveContent } from './StepObjectiveContent'

export const StepObjective = observer(() => {
  const { errorObjective } = useChatbotContext()

  return (
    <SectionCollapse
      icon={'target'}
      title='Collect data'
      tooltipProps={{
        label: 'Gather specific details like team size, budget, and more',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={errorObjective}
    >
      <StepObjectiveContent type={'default'} error={errorObjective} />
    </SectionCollapse>
  )
})
